import { CATEGORIES_ACTION_TYPE } from "./category.types";

import { createAction } from "../../Utils/Reducer/reducer.utils";

export const setCategories = (categoriesArray) =>
  createAction(CATEGORIES_ACTION_TYPE.SET_CATEGORIES, categoriesArray);
